import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import ShowMoreIcon from '@atlaskit/icon/core/align-text-left';

import type { GlobalShortcutsProps, ViewAllAppsConfig } from '../../types';
import { ShortcutMenuItem } from '../shortcut-menu-item';

import { messages } from './messages';

export type ViewAllAppsItemProps = Pick<GlobalShortcutsProps, 'product'> & ViewAllAppsConfig;

const analyticsName = 'VIEW_ALL_APPS';

export function ViewAllAppsItem({
	path,
	isSelected,
	product,
	onNavigate,
}: ViewAllAppsItemProps): React.JSX.Element | null {
	const { formatMessage } = useIntl();

	// Memoise the `shortcut` object so the
	// memoised `ShortcutMenuItem` isn't handed a brand-new object (with a fresh
	// icon element) on every render, which would defeat its memo. Hooks must run
	// unconditionally, so this is computed before the early `path` guard below.
	const shortcut = useMemo(
		() => ({
			key: analyticsName,
			analyticsName,
			label: formatMessage(messages.viewAllAppsLabel),
			icon: <ShowMoreIcon label="" />,
			url: path,
			isReorderable: false as const,
			type: 'internal' as const,
			isSelected,
			onClick: onNavigate,
		}),
		[formatMessage, path, isSelected, onNavigate],
	);

	if (!path || path.trim().length < 1) {
		return null;
	}

	return <ShortcutMenuItem shortcut={shortcut} product={product} />;
}
